module.exports = __webpack_public_path__ + "static/img/en_US1.f099e35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/en_US1.png
// module id = qN+W
// module chunks = 1